var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDefaultImageCourseDark = function SvgDefaultImageCourseDark(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 4,
    fill: "#292C2F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#defaultImageCourseDark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.948 41.844c-3.072-.025-5.542-2.462-5.517-5.444.025-2.981 2.537-5.379 5.609-5.354 3.072.024 5.542 2.462 5.517 5.443-.025 2.982-2.537 5.38-5.609 5.355Zm12.037-5.408c.151-2.867-.861-7.56-3.341-11.397-.066-.1-.178-.06-.154.045.166.585.205 1.642-.753 1.58-1.697-.111.06-3.636-3.668-6.082-.074-.049-.163.017-.123.095.256.471.408 1.941-.183 2.443-.473.401-1.343.293-2.18-1.03-1.393-2.207-.864-4.566.083-6.04.071-.11-.026-.154-.107-.128-5.128 1.642-6.151 7.507-7.242 9.646-.183.359-.342.546-.655.526-.934-.06-.261-1.994.062-2.667.046-.095-.067-.148-.127-.086-2.64 2.677-5.03 7.236-5.484 11.472.015-.1-.042.35-.07.68a14.301 14.301 0 0 0-.043.856c-.054 6.429 5.272 11.683 11.895 11.736 6.624.053 12.038-5.116 12.093-11.544l-.003-.105Z",
    fill: "#191C1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "defaultImageCourseDark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(20 15.915)",
    d: "M0 0h24v32.17H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDefaultImageCourseDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/defaultImageCourseDark.svg";